import { useEffect, useState } from "react";
import { streamExplain } from "../../lib/opportunityApi";

const IDLE = { status: "idle", facts: null, model: null, text: "", done: null, error: null };

// Streams the Today's Opportunity explanation: facts arrive first (meta), then the AI text; a saved answer comes back at once.
export function useOpportunity(req) {
  const [s, setS] = useState(IDLE);
  useEffect(() => {
    if (!req) { setS(IDLE); return undefined; }
    const ctl = new AbortController();
    let alive = true;
    const set = (fn) => alive && setS(fn);
    setS({ ...IDLE, status: "loading" });
    streamExplain(!!req.fresh, {
      signal: ctl.signal,
      onMeta: m => set(p => ({ ...p, facts: m.facts, model: m.model })),
      onToken: t => set(p => ({ ...p, status: "streaming", text: p.text + t })),
      onDone: d => set(p => ({ ...p, status: d.empty ? "empty" : "done", done: d })),
    }).catch(e => e.name !== "AbortError" && set(p => ({ ...p, status: "error", error: e.message })));
    return () => { alive = false; ctl.abort(); };
  }, [req]);
  return s;
}
